<template>
  <v-container
    fluid
  >
    <v-row
      class="docs align-start justify-center"
      wrap
    >
      <v-col>
        <v-row class="justify-space-between px-2">
          <v-col class="col-auto">
            <span class="headline font-weight-bold">Documentation</span>
          </v-col>

          <v-col class="col-auto">
            <v-row>
              <v-col>
                <!-- Button -->
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="mt-0">
          <v-col>
            <v-divider />
          </v-col>
        </v-row>

        <v-row>
          <!-- Navigation -->
          <v-col
            class="col-auto"
            style="min-width: 300px;"
          >
            <v-list>
              <v-list-item-group>
                <v-list-item
                  v-for="item in navItems"
                  :key="item.title"
                  @click="selectNavItem(item)"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <router-link
                        :to="`/docs/${item.reportId}`"
                        :class="{
                          'font-weight-bold': reportId === item.reportId,
                          'text-decoration-none': true,
                          'text-primary': reportId === item.reportId,
                        }"
                        class="cursor-pointer"
                      >
                        <span :class="`caption ${reportId === 'dashboard' ? 'font-weight-bold' : ''}`">{{ item.title }}</span>
                      </router-link>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>

          <!-- Content -->
          <v-col>
            <v-card class="elevation-0">
              <v-card-text
                v-if="reportId === 'dashboard'"
                class="pa-6"
              >
                <v-row>
                  <WelcomeCard />
                </v-row>
              </v-card-text>

              <v-card-text
                v-else-if="reportId === 'release-notes' || reportId === 'releases'"
                class="pa-6"
              >
                <v-row>
                  <ReleaseNotes />
                </v-row>
              </v-card-text>

              <v-card-text
                v-else-if="reportId === 'features'"
                class="pa-6"
              >
                <v-row>
                  <doc-card
                    v-if="reportId === 'features'"
                    title="Features"
                    type="feature"
                  />
                </v-row>
              </v-card-text>

              <v-card-text
                v-else-if="reportId === 'filters'"
                class="pa-6"
              >
                <v-row>
                  <doc-card
                    v-if="reportId === 'filters'"
                    title="Filters"
                    type="filter"
                  />
                </v-row>
              </v-card-text>

              <v-card-text
                v-else-if="reportId === 'roadmaps'"
                class="pa-6"
              >
                <v-row>
                  <doc-card
                    v-if="reportId === 'roadmaps'"
                    title="Roadmaps"
                    type="roadmap"
                  />
                </v-row>
              </v-card-text>

              <v-card-text
                v-else-if="reportId === 'legal'"
                class="pa-6"
              >
                <v-row>
                  <doc-card
                    v-if="reportId === 'legal'"
                    title="Legal"
                    type="legal"
                  />
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'DocApp',
  components: {
    DocCard: () => import('../components/DocCard.vue'),
    ReleaseNotes: () => import('./ReleaseNotes.vue'),
    WelcomeCard: () => import('../components/WelcomeCard.vue'),
  },
  data() {
    return {
      navItems: [
        { title: 'Welcome', subtitle: 'Learn the basics of iAdOps', reportId: 'welcome' },
        { title: 'Releases', subtitle: 'Review the latest updates', reportId: 'releases' },
        { title: 'Features', subtitle: 'Discover the features available', reportId: 'features' },
        { title: 'Filters', subtitle: 'Learn more about filtering.', reportId: 'filters' },
        // { title: 'Roadmaps', subtitle: 'Future plans and roadmaps', reportId: 'roadmaps' },
        { title: 'Other', subtitle: 'Legal and other information', reportId: 'other' },
      ],
    }
  },
  computed: {
    reportId() {
      return this.$route.params.reportId || 'releases'
    },
  },
  methods: {
    selectNavItem(item) {
      // Log event to Google Analytics.
      this.$analytics.event('goal_completion', {
        category: 'View Documentation',
        description: 'Navigate to Doc',
        label: `Navigated to doc titled "${item.title}"`,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~src/styles/variables";

.docs {
  .docs-card {
    border-radius: 6px;
    box-shadow: 0 2px 6px 0 rgba(0, 148, 255, 0.21);
  }

  .card-title {
    font-size: medium;
    font-weight: bold;
    letter-spacing: 0.69px;
    line-height: 29px;
  }

  .welcome-card {
    .card-title {
       color: $color-monochrome-brightblue;
      justify-content: center;
    }
  }
}
</style>
